<template>
  <div class="proxy-info-container">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb-nav">
      <el-breadcrumb-item :to="{ path: '/Welcome' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>代理信息</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 主要内容卡片 -->
    <el-card class="main-card" shadow="never">
      <el-form
              ref="formForRef"
              :model="addForm"
              :rules="rules"
              label-width="120px"
              class="proxy-form"
              size="small"
      >
        <!-- 标签页 -->
        <el-tabs v-model="activeName" class="form-tabs">
          <!-- 基本信息标签页 -->
          <el-tab-pane label="基本信息" name="first">
            <div class="tab-content">
              <!-- 第一行：省市、名称、代理等级 -->
              <el-row :gutter="32" class="form-row">
                <el-col :xs="24" :sm="12" :md="8" :lg="8">
                  <el-form-item label="所属省市" prop="province_id" class="form-item">
                    <el-cascader
                            ref="cascaderAddr"
                            v-model="areaList"
                            :props="propsdata"
                            :key="isResouceone"
                            @change="handleChangeAddress"
                            placeholder="请选择省市"
                            style="width: 100%;"
                            clearable
                    ></el-cascader>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8">
                  <el-form-item label="名称" prop="real_name" class="form-item">
                    <el-input
                            v-model="addForm.real_name"
                            placeholder="请输入名称"
                            clearable
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8">
                  <el-form-item label="代理等级" class="form-item">
                    <el-select
                            v-model="addForm.grade_id"
                            placeholder="请选择代理等级"
                            style="width: 100%;"
                            clearable
                    >
                      <el-option
                              v-for="item in gradeList"
                              :key="item.id"
                              :label="item.name"
                              :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>

              <!-- 第二行：所属代理 -->
              <el-row :gutter="32" class="form-row">
                <el-col :xs="24" :sm="12" :md="8" :lg="8">
                  <el-form-item label="所属代理" prop="cat_id" class="form-item">
                    <el-select
                            v-model="addForm.pid"
                            placeholder="请选择所属代理"
                            style="width: 100%;"
                            @change="handleIsopenSelect"
                            clearable
                    >
                      <el-option
                              v-for="item in cateMenus"
                              :key="item.id"
                              :label="item.id > 0 ? '|--' + item.real_name : item.real_name"
                              :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>

              <!-- 第三行：编号、负责人、入驻时间 -->
              <el-row :gutter="32" class="form-row">
                <el-col :xs="24" :sm="12" :md="8" :lg="8">
                  <el-form-item label="编号" class="form-item">
                    <el-input
                            v-model="addForm.contract_sn"
                            placeholder="请输入合同编号"
                            clearable
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8">
                  <el-form-item label="营业执照负责人"  class="form-item">
                    <el-input
                            v-model="addForm.artiperson"
                            placeholder="请输入营业执照负责人"
                            clearable
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8">
                  <el-form-item label="入驻时间" class="form-item">
                    <el-date-picker
                            v-model="addForm.contract_start_time"
                            type="date"
                            placeholder="选择合同开始时间"
                            value-format="yyyy-MM-dd"
                            style="width: 100%;"
                            clearable
                    ></el-date-picker>
                  </el-form-item>
                </el-col>
              </el-row>

              <!-- 第四行：联系人、电话、手机 -->
              <el-row :gutter="32" class="form-row">
                <el-col :xs="24" :sm="12" :md="8" :lg="8">
                  <el-form-item label="联系人" class="form-item">
                    <el-input
                            v-model="addForm.cont_name"
                            placeholder="请输入联系人"
                            clearable
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8">
                  <el-form-item label="联系电话" class="form-item">
                    <el-input
                            v-model="addForm.telephone"
                            placeholder="请输入联系电话"
                            clearable
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8">
                  <el-form-item label="联系手机" class="form-item">
                    <el-input
                            v-model="addForm.mobile"
                            placeholder="请输入联系手机"
                            clearable
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>

              <!-- 第五行：地址 -->
              <el-row :gutter="32" class="form-row">
                <el-col :span="24">
                  <el-form-item label="地址" class="form-item">
                    <el-input
                            v-model="addForm.address"
                            placeholder="请输入详细地址"
                            clearable
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>

              <!-- 图片上传区域 -->
              <el-row :gutter="32" class="form-row">
                <el-col :span="24">
                  <el-form-item label="代理图片" class="form-item">
                    <div class="upload-container">
                      <el-upload
                              class="image-uploader"
                              drag
                              action="#"
                              :file-list="fileList"
                              :before-upload="handleBeforeUpload"
                              :on-change="uploadFile"
                              :auto-upload="false"
                              list-type="picture-card"
                              :on-preview="handlePreview"
                              :on-remove="handleRemove"
                              accept=".jpg,.jpeg,.png"
                      >
                        <i class="el-icon-upload"></i>
                        <div class="el-upload__text">
                          将图片拖到此处，或<em>点击上传</em>
                        </div>
                        <div class="el-upload__tip" slot="tip">
                          支持JPG、PNG格式，图片大小不超过2MB，建议尺寸800×600px
                        </div>
                      </el-upload>
                    </div>
                  </el-form-item>
                </el-col>
              </el-row>

              <!-- 图片URL -->
              <el-row :gutter="32" class="form-row">
                <el-col :span="24">
                  <el-form-item label="图片URL" class="form-item">
                    <el-input
                            v-model="addForm.shop_img"
                            placeholder="图片上传后自动生成URL"
                            readonly
                            class="url-input"
                    >
                      <template slot="append">
                        <el-button
                                icon="el-icon-document-copy"
                                @click="copyUrl"
                                v-if="addForm.shop_img"
                        ></el-button>
                      </template>
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </el-tab-pane>

          <!-- 详情标签页 -->
          <el-tab-pane label="详情" name="second">
            <div class="tab-content">
              <el-row>
                <el-col :span="24">
                  <div class="editor-container">
                    <div class="editor-header">
                      <span class="editor-title">代理详情描述</span>
                      <div class="editor-tips">
                        <i class="el-icon-info"></i>
                        <span>在这里详细描述代理的业务范围、优势等信息</span>
                      </div>
                    </div>
                    <div class="editor-wrapper">
                      <Toolbar
                              :editor="editor"
                              :defaultConfig="toolbarConfig"
                              :mode="mode"
                              class="editor-toolbar"
                      />
                      <Editor
                              v-model="addForm.description"
                              :defaultConfig="editorConfig"
                              :mode="mode"
                              @onCreated="onCreated"
                              @onChange="onChange"
                              class="editor-content"
                      />
                    </div>
                  </div>
                </el-col>
              </el-row>
            </div>
          </el-tab-pane>
        </el-tabs>

        <!-- 操作按钮 -->
        <div class="form-actions">
          <el-button
                  type="primary"
                  icon="el-icon-check"
                  @click="submitForm"
                  :loading="loading"
                  class="submit-btn"
          >
            保存信息
          </el-button>
          <el-button
                  icon="el-icon-back"
                  @click="$router.push('/proxyList')"
                  class="cancel-btn"
          >
            返回列表
          </el-button>
        </div>
      </el-form>
    </el-card>
  </div>
</template>

<script>
  import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
  import axios from 'axios'
  import moment from 'moment'

  export default {
    name: 'proxyForm',
    components: { Editor, Toolbar },
    data() {
      return {
        activeName: 'first',
        loading: false,
        gradeList: [],
        fileList: [],
        shopList: [],
        dicList: [],
        provinceList: [],

        addForm: {
          id: '',
          artiperson: '',
          basic_name: '',
          work_status: '',
          status: '',
          real_name: '',
          contract_sn: '',
          contract_start_time: '',
          contract_end_time: '',
          grade_id: '',
          province_id: '',
          city_id: '',
          district_id: '',
          sex: '',
          amount: '',
          id_code: '',
          mobile: '',
          remark: '',
          order_time: '',
          summary: '',
          manager_name: '',
          unit_name: '',
          telephone: '',
          address: '',
          cont_name: '',
          shop_id: '',
          description: '',
          shop_img: '',
          pid:parseInt(sessionStorage.getItem('proxy_id')),
          access_token: sessionStorage.getItem('token'),
          company_id: sessionStorage.getItem('company_id'),
          creator_id: sessionStorage.getItem('user_id'),
        },

        cateMenus: [],
        editor: null,
        toolbarConfig: {
          excludeKeys: [
            'group-video',
            'fullScreen'
          ]
        },
        editorConfig: {
          placeholder: '请输入代理详情内容...',
          MENU_CONF: {
            uploadImage: {
              customUpload: this.uploadImg,
              maxFileSize: 2 * 1024 * 1024, // 2M
              allowedFileTypes: ['image/*']
            }
          }
        },
        mode: 'default',

        rules: {
          real_name: [
            { required: true, message: '请输入代理名称', trigger: 'blur' },
            { min: 2, max: 50, message: '长度在 2 到 50 个字符', trigger: 'blur' }
          ],
          province_id: [
            { required: true, message: '请选择所属省市', trigger: 'change' }
          ],
          grade_id: [
            { required: true, message: '请选择代理等级', trigger: 'change' }
          ],
          artiperson: [
            { required: true, message: '请输入营业执照负责人', trigger: 'blur' }
          ]
        },

        areaList: [],
        isResouceone: false,
        propsdata: {
          lazy: true,
          lazyLoad: this.lazyLoadArea
        }
      }
    },

    mounted() {
      this.initData()
    },

    methods: {
      async initData() {
        await this.getCateMenus()
        await this.getGradeList()

        const id = this.$route.query.id
        if (!isNaN(id) && id > 0) {
          this.addForm.id = id
          await this.getOne()
        }
      },

      lazyLoadArea(node, resolve) {
        const { level } = node
        setTimeout(() => {
          const url = '/api/api/cmp.sys.Region_read_lz/findRegionList'
          const params = {
            access_token: sessionStorage.getItem('token'),
            company_id: sessionStorage.getItem('company_id'),
            parent_id: level === 0 ? 1 : node.value
          }

          axios.post(url, params).then((res) => {
            if (res.data.code === 200) {
              const nodes = res.data.data.map((item) => ({
                value: item.id,
                label: item.name,
                leaf: level >= 2
              }))
              resolve(nodes)
            }
          })
        }, 100)
      },



      async getCateMenus() {
        try {
          const params = {
            access_token: sessionStorage.getItem('token'),
            company_id: sessionStorage.getItem('company_id'),
            pid: sessionStorage.getItem('proxy_id')
          }
          const res = await this.$axios.findProxyTable(params)
          if (res.code === 200) {
            this.cateMenus = res.data
          }
        } catch (error) {
          console.error('获取代理列表失败:', error)
        }
      },

      async getGradeList() {
        try {
          const params = {
            access_token: sessionStorage.getItem('token'),
            company_id: sessionStorage.getItem('company_id')
          }
          const res = await this.$axios.findProxyGradeList(params)
          if (res.code === 200) {
            this.gradeList = res.data
          }
        } catch (error) {
          console.error('获取代理等级失败:', error)
        }
      },

      handleRemove(file) {
        if (file.url === this.addForm.shop_img) {
          this.addForm.shop_img = ''
        }
      },

      handlePreview(file) {
        window.open(file.url)
      },

      submitForm() {
        this.$refs.formForRef.validate(async (valid) => {
          if (valid) {
            this.loading = true
            try {
              const res = await this.$axios.proxySave(this.addForm)
              if (res.code === 200) {
                this.$message.success('保存成功')
                this.$router.push('/proxyList')
              } else {
                this.$message.error(res.message || '保存失败')
              }
            } catch (error) {
              console.error('保存失败:', error)
              this.$message.error('保存失败，请重试')
            } finally {
              this.loading = false
            }
          }
        })
      },

      async getOne() {
        try {
          const params = {
            access_token: this.addForm.access_token,
            company_id: this.addForm.company_id,
            id: this.addForm.id
          }
          const res = await this.$axios.proxyOne(params)
          if (res.code === 200) {
            const item = res.data
            this.setFormData(res.data)

            // 单独处理省市县（延迟执行，等待级联选择器初始化）
            if (item.province_id && item.city_id && item.district_id) {
              setTimeout(() => {
                this.areaList = [
                  parseInt(item.province_id),
                  parseInt(item.city_id),
                  parseInt(item.district_id)
                ]

                // 强制重新渲染
                this.isResouceone = !this.isResouceone

                // 触发 change 事件更新表单数据
                this.handleChangeAddress(this.areaList)
              }, 500) // 稍微延迟确保组件已渲染
            }
          }
        } catch (error) {
          console.error('获取代理信息失败:', error)
        }
      },
// 修改 handleChangeAddress 方法，确保它能处理空值
      handleChangeAddress(value) {
        console.log('地区选择变化:', value)

        if (value && value.length >= 3) {
          this.addForm.province_id = parseInt(value[0])
          this.addForm.city_id = parseInt(value[1])
          this.addForm.district_id = parseInt(value[2])
        } else {
          // 清空地区信息
          this.addForm.province_id = ''
          this.addForm.city_id = ''
          this.addForm.district_id = ''
        }
      },
      setFormData(item) {
        Object.keys(this.addForm).forEach(key => {
          if (key in item) {
            this.addForm[key] = item[key] || ''
          }
        })


        if (item.contract_start_time) {
          this.addForm.contract_start_time = moment(item.contract_start_time * 1000).format('YYYY-MM-DD')
        }

        if (item.contract_end_time) {
          this.addForm.contract_end_time = moment(item.contract_end_time * 1000).format('YYYY-MM-DD')
        }

        if (item.shop_img) {
          this.fileList = [{
            name: item.real_name || '代理图片',
            url: item.shop_img
          }]
        }
      },

      uploadFile(item) {
        this.uploadToOSS(item.raw)
      },

      async uploadToOSS(file) {
        try {
          const param = {
            access_token: sessionStorage.getItem('token'),
            company_id: sessionStorage.getItem('company_id')
          }

          const res = await this.$axios.getAliJsonCmp(param)
          const data = res.data

          const suffix = this.get_suffix(file.name)
          const autoname = this.Ymdhis()
          const path = data.path ? data.path : ''

          const formData = new FormData()
          formData.append('key', data.dir + path + autoname + suffix)
          formData.append('policy', data.policy)
          formData.append('OSSAccessKeyId', data.accessid)
          formData.append('success_action_status', '200')
          formData.append('Signature', data.signature)
          formData.append('file', file)

          const uploadRes = await axios.post(data.host, formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
          })

          const fileurl = uploadRes.data.filename
          const fullurl = data.host + '/' + fileurl

          this.addForm.shop_img = fullurl
          this.fileList = [{
            name: file.name,
            url: fullurl
          }]

          this.$message.success('图片上传成功')
        } catch (error) {
          console.error('上传失败:', error)
          this.$message.error('图片上传失败')
        }
      },

      uploadImg(file, insertFn) {
        this.uploadToOSS(file).then(() => {
          insertFn(this.addForm.shop_img)
        })
      },

      copyUrl() {
        if (!this.addForm.shop_img) return

        navigator.clipboard.writeText(this.addForm.shop_img)
                .then(() => {
                  this.$message.success('URL已复制到剪贴板')
                })
                .catch(() => {
                  // 降级方案
                  const input = document.createElement('input')
                  input.value = this.addForm.shop_img
                  document.body.appendChild(input)
                  input.select()
                  document.execCommand('copy')
                  document.body.removeChild(input)
                  this.$message.success('URL已复制到剪贴板')
                })
      },

      onCreated(editor) {
        this.editor = Object.seal(editor)
      },

      onChange() {
        // 可以在这里添加内容变化的处理逻辑
      },

      get_suffix(filename) {
        const pos = filename.lastIndexOf('.')
        return pos !== -1 ? filename.substring(pos) : ''
      },

      Ymdhis() {
        const date = new Date()
        const year = date.getFullYear()
        const month = String(date.getMonth() + 1).padStart(2, '0')
        const day = String(date.getDate()).padStart(2, '0')
        const hour = String(date.getHours()).padStart(2, '0')
        const minute = String(date.getMinutes()).padStart(2, '0')
        const second = String(date.getSeconds()).padStart(2, '0')
        return `${year}${month}${day}${hour}${minute}${second}`
      },

      handleIsopenSelect() {
        // 处理代理选择逻辑
      },

      handleClick(tab) {
        console.log('切换到标签:', tab.name)
      },

      handleBeforeUpload(file) {
        const isImage = file.type.startsWith('image/')
        const isLt2M = file.size / 1024 / 1024 < 2

        if (!isImage) {
          this.$message.error('只能上传图片文件!')
          return false
        }
        if (!isLt2M) {
          this.$message.error('图片大小不能超过 2MB!')
          return false
        }
        return true
      }
    },

    beforeDestroy() {
      if (this.editor) {
        this.editor.destroy()
      }
    }
  }
</script>

<style scoped>
  .proxy-info-container {
    padding: 20px;
    background-color: #f5f7fa;
    min-height: calc(100vh - 60px);
  }

  .breadcrumb-nav {
    margin-bottom: 20px;
    font-size: 14px;
  }

  .main-card {
    border-radius: 8px;
    border: 1px solid #ebeef5;
    background: #fff;
  }

  .main-card >>> .el-card__body {
    padding: 30px;
  }

  .form-tabs >>> .el-tabs__nav-wrap::after {
    height: 1px;
  }

  .form-tabs >>> .el-tabs__item {
    font-size: 16px;
    font-weight: 500;
    padding: 0 24px;
    height: 50px;
    line-height: 50px;
  }

  .form-tabs >>> .el-tabs__active-bar {
    height: 3px;
    border-radius: 3px;
  }

  .tab-content {
    padding: 20px 0;
  }

  .form-row {
    margin-bottom: 24px;
  }

  .form-item >>> .el-form-item__label {
    font-weight: 500;
    color: #606266;
  }

  .form-item >>> .el-input__inner,
  .form-item >>> .el-textarea__inner {
    border-radius: 4px;
  }

  .upload-container {
    margin: 10px 0;
  }

  .image-uploader >>> .el-upload-dragger {
    width: 100%;
    height: 180px;
    border-radius: 8px;
    border: 2px dashed #dcdfe6;
    background-color: #fafafa;
  }

  .image-uploader >>> .el-upload-dragger:hover {
    border-color: #409eff;
  }

  .image-uploader >>> .el-upload__tip {
    margin-top: 10px;
    font-size: 12px;
    color: #909399;
  }

  .url-input >>> .el-input-group__append {
    padding: 0;
  }

  .url-input >>> .el-button {
    border-radius: 0 4px 4px 0;
  }

  .editor-container {
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    overflow: hidden;
  }

  .editor-header {
    padding: 12px 16px;
    background: #f5f7fa;
    border-bottom: 1px solid #dcdfe6;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .editor-title {
    font-weight: 600;
    color: #303133;
  }

  .editor-tips {
    font-size: 12px;
    color: #909399;
  }

  .editor-tips i {
    margin-right: 5px;
  }

  .editor-wrapper {
    height: 400px;
    overflow: hidden;
  }

  .editor-toolbar {
    border-bottom: 1px solid #dcdfe6;
    background: #f8f9fa;
  }

  .editor-content {
    height: 350px;
    overflow-y: auto;
  }

  .form-actions {
    margin-top: 40px;
    padding-top: 20px;
    border-top: 1px solid #ebeef5;
    text-align: center;
  }

  .submit-btn {
    min-width: 120px;
    height: 40px;
    border-radius: 4px;
  }

  .cancel-btn {
    min-width: 120px;
    height: 40px;
    border-radius: 4px;
  }

  /* 响应式调整 */
  @media (max-width: 768px) {
    .proxy-info-container {
      padding: 10px;
    }

    .main-card >>> .el-card__body {
      padding: 20px 15px;
    }

    .form-row {
      margin-bottom: 16px;
    }

    .form-item >>> .el-form-item__label {
      padding-right: 10px;
      margin-bottom: 8px;
      display: block;
      width: 100% !important;
      text-align: left;
    }

    .form-item >>> .el-form-item__content {
      margin-left: 0 !important;
    }

    .form-actions {
      display: flex;
      flex-direction: column;
      gap: 10px;
    }

    .submit-btn,
    .cancel-btn {
      width: 100%;
    }
  }

  /* 动画效果 */
  .el-form-item {
    transition: all 0.3s ease;
  }

  .el-button {
    transition: all 0.3s ease;
  }

  /* 自定义滚动条 */
  .editor-content::-webkit-scrollbar {
    width: 6px;
  }

  .editor-content::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  .editor-content::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 3px;
  }

  .editor-content::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
  }
</style>

<style src="@wangeditor/editor/dist/css/style.css"></style>
